import { AA, BNC, CCRC, MC, SNF, TOCS } from '@sly/core/constants/filters';

interface TocOptions {
  label: string;
  value: string;
}

export const DATA_HUB_TOC_OPTIONS = Object.entries(TOCS).reduce(
  (acc, [key, { label, value }]) => {
    if (![CCRC, AA, SNF, CCRC, BNC, MC].includes(key)) {
      acc.push({
        label: label,
        value: value,
      });
    }
    return acc;
  },
  [] as TocOptions[]
);

export const ROOM_OPTIONS = [
  {
    label: 'Shared room',
    value: 'shared-room',
  },
  {
    label: 'Studio room',
    value: 'studio',
  },
  {
    label: '1 Bedroom',
    value: 'one-bedroom',
  },
  {
    label: '2 Bedroom',
    value: 'two-bedroom',
  },
];
